import * as actions from './actions';
import Model from '../model';
import request from 'superagent';
import {toast} from 'react-toastify'

import {NetworkSelector} from '/app/src/model/selectors'
import CustomizationSelector from './selector'


class Customization extends Model {

    constructor(){
        super()
        this.selector = CustomizationSelector
    }

    put(customization){
        return (dispatch) => {
            dispatch(actions.customizationReadSuccess(customization));
        }
    }

    read() {
        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'CUSTOMIZATION_READ')
            }
        }

        const dispatchFunction = () => {
            return (dispatch) => {
                const url = this.url()
                const token = this.token()
                dispatch(actions.customizationReadRequest());
                return request
                    .get(`${url}/v1/company/customization`)
                    .send({})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .end((err, res) => {
                        if (res.statusCode === 200) {
                            dispatch(actions.customizationReadSuccess(res.body.customization));
                        } else{
                            dispatch(actions.customizationReadFailure(err, res));
                        }
                    });
        }}

        return {
            selector: selectorFunction, dispatcher: dispatchFunction
        }
    }

    offlineSettingsGet() {
        const selectorFunction = (state) => {
            return {
                'network': NetworkSelector.get(state, 'CUSTOMIZATION_OFFLINE_SETTINGS_READ')
            }
        }

        const dispatchFunction = () => {
            return (dispatch) => {
                const url = this.url()
                const token = this.token()
                dispatch(actions.customizationReadRequest());
                return request
                    .get(`${url}/v2/company/customization/offline_settings/get`)
                    .send({})
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .end((err, res) => {
                        if (res.statusCode === 200) {
                            dispatch(actions.offlineSettingsGetSuccess(res.body.offline_settings));
                        } else{
                            dispatch(actions.offlineSettingsGetFailure(err, res));
                        }
                    });
        }}
        return {
            selector: selectorFunction, dispatcher: dispatchFunction
        }
    }

    updates() {
        const selectorFunction = {
            customization: (state)=>this.selector.getFrom(state).toJS()
        }
        const dispatchFunction = (updates) => {
            const url = this.url()
            const token = this.token()
            return (dispatch) => {
                return request
                    .put(`${url}/v1/company/customization/update`)
                    .send({
                        updates: updates
                    })
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .end((err, res) => {
                        if (res.statusCode === 200) {
                            dispatch(actions.customizationUpdateSuccess(res.body.customization));
                        }else {
                            dispatch(actions.customizationReadFailure(err, res));
                    }
                });
            }
        }
        return {selector: selectorFunction, dispatcher: dispatchFunction}
    }

    update(color, displayName, language, timezone) {
        const url = this.url()
        const token = this.token()
        return (dispatch) => {
            return request
                .put(`${url}/v1/company/customization/update`)
                .send({
                    updates: {
                        color: color,
                        company_display_name: displayName,
                        default_language: language,
                        timezone: timezone
                    }
                })
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.customizationUpdateSuccess(res.body.customization));
                        toast.success('Uppdaterat ClientChat')
                    }else {
                        dispatch(actions.customizationReadFailure(err, res));
                    }
                });
        }
    }

    updateOfflineFormular(conditionId, conditions){
        const url = this.url()
        const token = this.token()
        return (dispatch) => {
            return request
                .post(`${url}/v1/company/customization/offline_condition/update`)
                .send({
                    'condition_id': conditionId,
                    'conditions': conditions
                })
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.customizationUpdateSuccess(res.body.customization));
                    }else {
                        dispatch(actions.customizationReadFailure(err, res));
                    }
                });
        }
    }

    updateRequest() {
        const selectorFunction = (state) => {
            return {
                'customization': CustomizationSelector.getCustomization(state),
                'network': NetworkSelector.get(state, 'customization update')
            }
        }
        const dispatchFunction = (updates) => {
            const url = this.url()
            const token = this.token()
            return (dispatch) => {
                dispatch({type: 'customization update requested'})
                return request
                    .put(`${url}/v1/company/customization/update`)
                    .send({ updates: updates })
                    .set('Authorization', 'Bearer ' + token)
                    .accept('application/json')
                    .set('Content-Type', 'application/json')
                    .end((err, res) => {
                        if (res.statusCode === 200) {
                            dispatch({
                                type: 'customization update succeeced',
                                payload: res.body.customization
                            })

                        }else {
                            dispatch({
                                type: 'customization update failed',
                                error: err
                            });
                        }
                });
            }
        }
        return { selector: selectorFunction, dispatcher: dispatchFunction }
    }
}

export default new Customization();



// WEBPACK FOOTER //
// ./src/model/Customization/model.js